module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_m_leucistic.960c695b.png";